module.exports = __webpack_public_path__ + "img/selected0-min.f1aec8fd.png";